<div class="container">
  <div class="card">
    <div class="card-body">
      <app-loader [hidden]="!isLoading"></app-loader>
      <div class="row" [hidden]="isLoading">
        <form *ngIf="formActive" [formGroup]="form" (ngSubmit)="submitForm()" class="form col">
          <div *ngIf="departmentTargetsArray().controls?.length" formArrayName="department_targets">
            <ng-container *ngFor="let departmentTargetGroup of departmentTargetsArray().controls; let i = index">
              <div [formGroupName]="i">
                <h5>{{ departmentTargetGroup.get('department.name_' + currentLanguage)?.value }}</h5>
                <ng-container *ngIf="accomplishmentTargetsArray(i).controls?.length">
                  <div formArrayName="targets" class="row">
                    <ng-container
                      *ngFor="let accomplishmentTarget of accomplishmentTargetsArray(i).controls; let j = index">
                      <div [formGroupName]="j" class="col-12 col-lg-6">
                        <app-input type="number" [formControlName]="'goal'"
                                   [label]="accomplishmentTarget.get('name_' + currentLanguage)?.value"
                                   [extraLabel]="false" [fullWidth]="true">
                        </app-input>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" class="primary-button" mat-raised-button>
              {{ 'SHARED.save' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

